import * as React from "react";

const styles = require('../FundNameRow/FundNameRow.pcss');

interface LProps{
    className?: string;
    name?: string;
    isIndex?: boolean;
}

export class FundNameDataCell extends React.Component<LProps, {}>{
    constructor(){
        super();
    }

    render(){
        return(
            <td className={ !this.props.isIndex ? styles.fundName : styles.sector_benchmark} colSpan={3} >{this.props.name || ''}</td>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/Rankia/Components/FundNameDataCell/FundNameDataCell.tsx